// John Eldhose 20180516
import { RestfulGet } from './Restful';

export async function isAuthenticated() {
  const isAuth = await RestfulGet('isAuthenticated', (response) => {
      return (response['data'])
    }, (error) => {
      console.log(error);
      return false;
    }
  );
  return isAuth;
}



// WEBPACK FOOTER //
// ./src/Api/isAuthenticated.js